import { Component, OnInit, ViewChild, ElementRef} from '@angular/core';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';

import {BancosServices, PageBusquedaObject, Bancos} from '../bancos-services.service';
import { LoginService } from '../../../login/login.service';
import { NotificationService } from '../../../notifications/notification.service';

@Component({
  selector: 'app-catalogo-bancos',
  templateUrl: './catalogo-bancos.component.html',
  styleUrls: ['./catalogo-bancos.component.css'],
  providers: [ NotificationService],
  preserveWhitespaces: true
})

export class CatalogoBancosComponent implements OnInit {
  busqueda: PageBusquedaObject = new PageBusquedaObject();
  totalItems: number;
  rotate: any;
  items: Bancos[];
  cargado: boolean;

  tipos = [{id: 'n', titulo: 'Nacional'}, {id: 'e', titulo: 'Extrangero'}];

  @ViewChild('titulo') title: ElementRef;
  @ViewChild('tipo') tipo: ElementRef;

  constructor(private notificationService: NotificationService,
    private router: Router,
    private bancoService: BancosServices,
    public loginService: LoginService
  ) {
    this.busqueda.criteriaSearch = {};
    this.busqueda.itemsPerPage = 10;
    this.busqueda.pageNumber = 0;
  }

  ngOnInit(): void {
    this.cargarCatalogo();
  }

  cargarCatalogo() {
    this.mostrarMensajeCarga();
  this.busqueda.criteriaSearch['gral_emp_id'] = this.loginService.empresa;
    this.bancoService.catalogo(this.busqueda).subscribe(
      response => {
        this.items = response.contenido.content;
        this.totalItems = response.contenido.totalElements;
        this.cerrarMensajeCarga();
      }, err => {
        this.cerrarMensajeCarga();
        if (err.error.mensaje == null || '' || undefined) {
          err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
        }
        Swal.fire({
          icon: 'error',
          title: 'TNK Ledger',
          text: err.error.mensaje
        })
        console.log(err);
      });
  }

  eliminar(dtoDelete: Bancos): void {
    Swal.fire({
      title: 'Eliminar',
      text: `¿Está seguro de eliminar este elemento?`,
      showCancelButton: true,
      confirmButtonText: 'Eliminar'
    }).then((result) => {
      if (result.value) {
        this.bancoService.delete(dtoDelete.id, this.loginService.usuario.id).subscribe(response => {
          Swal.fire('TNK Ledger', response.mensaje, 'success');
          this.buscarEnCatalogo();
        }, err => {
          if (err.error.mensaje == null || '' || undefined) {
            err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
          }
          Swal.fire({
            icon: 'error',
            title: 'TNK Ledger',
            text: err.error.mensaje
          })
          console.log(err);
        });
      }
    });
  }

  sortearPor(columnName: any): void {
    this.busqueda.column = columnName;
    this.busqueda.sort = true;
    this.busqueda.pageNumber = 0;
    switch (this.busqueda.order) {
      case 'desc':
        this.busqueda.order = 'asc';
        break;
      default:
        this.busqueda.order = 'desc';
        break;
    }
    this.cargarCatalogo();
  }
  cambiarPagina(event: any): void {
    this.busqueda.pageNumber = event.page - 1;
    this.cargarCatalogo();
  }
  buscarEnCatalogo(): void {
    this.busqueda.pageNumber = 0;
    this.cargarCatalogo();
  }

  filtroDeBusqueda(find: any, columnName: any): void {
    this.busqueda.criteriaSearch[columnName] = find;
  }

  limpiarBusqueda(): void {
    this.busqueda.criteriaSearch = {};
    this.busqueda.itemsPerPage = 10;
    this.busqueda.pageNumber = 0;
    this.title.nativeElement.value = '';
    this.tipo.nativeElement.value = 0;
    this.cargarCatalogo();
  }
  mostrarMensajeCarga() {
    this.cargado = false;
    this.notificationService.showLoadingScreen('Procesando...');
  }
  cerrarMensajeCarga() {
    this.cargado = true;
    this.notificationService.closeLoadingScreen();
  }
}
